import { PathSegments } from '../../abstract/path-segments';

/** `admin/sponsors/{id}` as path segments, for sponsor sub-resources (`{ prefix: sponsorPrefix(id) }`). */
export function sponsorPrefix(sponsorId: string): PathSegments {
  return ['admin', 'sponsors', sponsorId];
}
